import { defineMessages } from 'react-intl';

export default defineMessages({
    classDetails: {
        id: 'app.components.ClassDetails.classDetails',
        defaultMessage: 'Class details'
    },
    className: {
        id: 'app.components.ClassDetails.className',
        defaultMessage: 'CLASS NAME'
    },
    year: {
        id: 'app.components.ClassDetails.year',
        defaultMessage: 'YEAR'
    },
    students: {
        id: 'app.components.ClassDetails.students',
        defaultMessage: 'STUDENTS'
    }
});



// WEBPACK FOOTER //
// ./app/components/class-detail/messages.js